/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITiposClientes from 'Infotrack@Modelos/smartStock/tiposClientes/entidades/tiposClientes';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import TiposClientesCM from '../controladorModelo/tiposClientesCM';
import { IFormularioTiposClientesCVProps } from '../interfaces';
import { acciones, IEstadoTiposClientes } from '../reductorTiposClientes';
import FormularioTiposClientesVista from '../vista/formularioTiposClientesVista';
import { useSelector } from 'react-redux';

const estadoInicial: ITiposClientes = {
    EmpresaId: '',
    TipoClienteDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const tiposClientesCM = new TiposClientesCM();

const FormularioTiposClientesCV: React.FunctionComponent<IFormularioTiposClientesCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadTiposClientes }, dispatch] = useProveedor<IEstadoTiposClientes>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITiposClientes>(estadoInicial);

    const theme = useTheme();
    const esMovil = useMediaQuery(theme.breakpoints.down('sm'));

    React.useEffect(() => {
        if (entidadTiposClientes && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTiposClientes);
        } else {
            reiniciar();
        }
    }, [entidadTiposClientes]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionTiposClientes = () => {
        if (tiposClientesCM.validarEntidad(mapearDatos())) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTiposClientes,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTiposClientes = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tiposClientesCM.crearTiposClientes(mapearDatos()).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            tiposClientesCM.editarTiposClientes(mapearDatos()).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    const mapearDatos = (): ITiposClientes => ({
        ...valor,
        AgenciaId: idAgencia,
        EmpresaId: IdEmpresa,
        Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
    });

    return (
        <FormularioTiposClientesVista
            accionCrearEditar={confirmarCreacionEdicionTiposClientes}
            cambiarInfoFomulario={alCambiarValor}
            esMovil={esMovil}
            tiposClientes={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioTiposClientesCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioTiposClientesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioTiposClientesCV);
